export default __webpack_public_path__ + "static/media/CNo.12-2.e0f2f507.jpg";